import { render, staticRenderFns } from "./PanelStats.vue?vue&type=template&id=0cf80e77&lang=pug&"
import script from "./PanelStats.vue?vue&type=script&lang=ts&"
export * from "./PanelStats.vue?vue&type=script&lang=ts&"
import style0 from "./PanelStats.vue?vue&type=style&index=0&id=0cf80e77&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports